<script setup lang="ts">
import { computed } from 'vue'

import { useImgSrcSet } from '../../composables/use-img-src-set'

import type { ComposedParagraphImage } from '@xcel-next/composer-schema'
import type { Brand } from '@xcel-next/core/enums'

const props = defineProps<{
  presenter: ComposedParagraphImage
  brand?: Brand
}>()

const { createImgSrc } = useImgSrcSet()

const imageUrl = computed(() => createImgSrc({
  image: props.presenter,
  brand: props.brand ?? '',
  type: 'webp',
  setName: 'presenter'
}))

const presenterUrl = computed(() => props.presenter.externalUrl || '#') // Fallback to prevent empty href
const presenterTarget = computed(() => props.presenter.externalUrl ? props.presenter.target || '_blank' : undefined)
const presenterRel = computed(() => props.presenter.externalUrl ? props.presenter.rel || 'sponsored' : undefined)
const imageAltText = computed(() => props.presenter.imageAltText || undefined)
</script>

<template>
  <div class="bx-content bx-presenter bx-typo--presenter">
    präsentiert von
    <a :href="presenterUrl"
       :target="presenterTarget"
       :rel="presenterRel">
      <figure>
        <img v-if="imageUrl"
             :src="imageUrl"
             :title="imageAltText"
             :alt="imageAltText">
      </figure>
    </a>
  </div>
</template>
